import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resetScroll } from './SmoothScroll';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // A new page starts at the top instantly. Animating the old page up to the
    // top after the new one has rendered made every navigation feel slow.
    resetScroll();
  }, [pathname]);

  return null;
};

export default ScrollToTop;
